import { render, staticRenderFns } from "./SendForReviewModal.vue?vue&type=template&id=46aec662"
import script from "./SendForReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SendForReviewModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports